<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-12">
				<b-card>
					<form id="container__form" @submit.prevent="save">
						<tooltip label="title" placement="right">
							<input
								name="title"
								v-model="record.title"
								v-validate="'required'"
								:class="{'form-control': true, 'is-invalid': errors.has('title')}"
								type="text"
							/>
							<span
								v-show="errors.has('title')"
								class="help invalid-feedback"
							>{{ $t(errors.first('title')) }}</span>
						</tooltip>
						<tooltip label="X" placement="right">
							<input
								name="x"
								v-model="record.x"
								v-validate="'required|decimal'"
								:class="{'form-control': true, 'is-invalid': errors.has('x')}"
								type="text"
							/>
							<span
								v-show="errors.has('x')"
								class="help invalid-feedback"
							>{{ $t(errors.first('x')) }}</span>
						</tooltip>
						<tooltip label="Y" placement="right">
							<input
								name="y"
								v-model="record.y"
								v-validate="'required|decimal'"
								:class="{'form-control': true, 'is-invalid': errors.has('y')}"
								type="text"
							/>
							<span
								v-show="errors.has('y')"
								class="help invalid-feedback"
							>{{ $t(errors.first('y')) }}</span>
						</tooltip>
						<tooltip label="Yaw" placement="right">
							<input
								name="yaw"
								v-model="record.yaw"
								v-validate="'required|decimal'"
								:class="{'form-control': true, 'is-invalid': errors.has('yaw')}"
								type="text"
							/>
							<span
								v-show="errors.has('yaw')"
								class="help invalid-feedback"
							>{{ $t(errors.first('yaw')) }}</span>
						</tooltip>
						<tooltip v-if="map == '0'" label="Map" label-for="maps">
							<b-form-group :horizontal="false">
								<b-form-select
									id="maps"
									:plain="true"
									:options="maps"
									v-model="record.map_id"
								></b-form-select>
							</b-form-group>
						</tooltip>
					</form>
				</b-card>
			</div>
			<ButtonSubmit />
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	import {ButtonSubmit} from '../../components'

	export default {
		name: 'locationsForm',
		components: {
			ButtonSubmit
		},
		data() {
			return {
				record_id: 0,
				maps: [],
				map: '0',
				record: {
					title: '',
					x: 0.0,
					y: 0.0,
					yaw: 0.0,
					map_id: ''
				},
			}
		},
		methods: {
			save(e) {
				e = e || window.event
				e.preventDefault()
				this.$validator.validateAll().then((result) => {
					if (result) {
						this.$root.loader = true
						axios
							.post(`/locations/${this.record_id}`, this.record)
							.then((response) => {
								this.$root.loader = false
								if (response.data.status === 1) {
									this.$router.push(`/locations/${this.map}/${response.data.data._id}/`)
								}
							})
					} else {
						// invalid
						this.$root.loader = false
					}
				})
			},

			fetchData() {
				if (this.record_id != 0) {
					this.$root.loader = true
					axios
						.get(`/locations/${this.record_id}`)
						.then((response) => {
							this.$root.loader = false
							if (response.data.status === 1) {
								this.record = response.data.data
							}
						})
				}
			},

			fetchMaps() {
				axios
					.get('/maps/list/all')
					.then((response) => {
						if (response.data.status === 1) {
							this.maps = response.data.data
						}
					})
			}
		},

		mounted() {
			this.record_id = this.$route.params.id;
			this.map = this.$route.params.map
			this.record.map_id = this.map
			this.fetchMaps();
			this.fetchData();
		},
	}
</script>
